export enum MessageButton {
  Ok,
  OkCancel,
  YesNoCancel,
  YesNo,
}

